import {useGetSalesRepReport} from '../hooks/useGetSalesRepReport'
import {SalesRepReportContext} from '../context'
import SalesRepReportTable from '../sections/table/SalesRepReportTable'
import {SalesRepReportHeader} from '../sections/header/SalesRepReportHeader'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetSalesRepTypeDropdown from '../hooks/useGetSalesRepTypeDropdown'

function SalesRepReport() {
  const {
    reportData: salesRepData,
    isLoading: isSalesRepLoading,
    filters: salesRepFilters,
    onSearch: onSalesRepSearch,
    onSortingChange: onSalesRepSortingChange,
    handleSalesRepReportDateChange,
    onChangeSalesRepTypeFilter,
  } = useGetSalesRepReport()

  const {
    entityPerformanceChartData: salesRepEntityPerformanceChartData,
    isLoading: isSalesRepEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onSalesRepEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onSalesRepEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onSalesRepEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: salesRepEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep')

  const {salesRepTypes, isLoading: isSalesRepDropdownLoading} = useGetSalesRepTypeDropdown()

  const contextValue = {
    salesRepData,
    isSalesRepLoading,
    salesRepFilters,
    onSalesRepSearch,
    onSalesRepSortingChange,
    handleSalesRepReportDateChange,
    onChangeSalesRepTypeFilter,

    salesRepTypes,
    isSalesRepDropdownLoading,

    salesRepEntityPerformanceChartData,
    isSalesRepEntityPerformanceChartDataLoading,
    onSalesRepEntityPerformanceChartIdChange,
    onSalesRepEntityPerformanceChartViewChange,
    onSalesRepEntityPerformanceChartDateRangeChange,
    salesRepEntityPerformanceChartFilters,
  }

  return (
    <SalesRepReportContext.Provider value={contextValue}>
      <SalesRepReportHeader />
      <SalesRepReportTable />
    </SalesRepReportContext.Provider>
  )
}

export default SalesRepReport
